import {
  SpecialConditionData,
  CustomConditionModel,
  SpecialConditionDataConditionType,
} from '@urbanx/agx.campaigns.client'

export const getModelFromCustomCondition = (
  customCondition: SpecialConditionData
): CustomConditionModel | undefined => {
  if (
    customCondition.conditionType !== SpecialConditionDataConditionType.Custom
  )
    return undefined

  return customCondition.customCondition
}
